import React from 'react';
import PropTypes from 'prop-types';
import { labelSizes } from './utils/customFieldData';
import Heading from '../../heading/heading';

const labelSizesList = Object.values(labelSizes);

export const CustomHeader = ({ field: { size, label } }) => {
  const sizeId = size?.id ?? size;
  const sizeData = labelSizesList.find(x => x.id === sizeId) ?? labelSizes.H6;

  return <Heading as={sizeData.name}>{label}</Heading>;
};

CustomHeader.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    size: PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.number,
      }),
      PropTypes.number,
    ]),
  }),
};
